/* eslint-disable no-shadow */
import UserModel from '@/common/models/user-model';

export const state = {
    users: [],
};

export const getters = {
};

export const mutations = {
    set(state, payload) {
        state.users = payload;
    },
    clear(state) {
        state.users = [];
    },
};

export const actions = ({api}) => ({
    async fetch({commit}, payload = {}) {
        commit('clear');
        const {params} = payload;
        const {items} = await api(({users}) => users.getAll(params));
        commit('set', items.map(({fields}) => new UserModel(fields)));
    },
});
